export default __webpack_public_path__ + "static/circle-0a157a546d19ef13e2ac139f4d35936d.webp";